export enum PhoneRequirement {
  Disabled = 'disabled',
  Optional = 'optional',
  Mandatory = 'mandatory',
}

export enum ShippingContactType {
  ShippingLabel = 'shipping_label',
  DigitalLabel = 'digital_label',
  ReturnLabel = 'return_label',
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum FieldName {
  ShippingContact = 'shipping_contact',
  BuyerPhoneNumber = 'buyer_phone_number',
  SellerPhoneNumber = 'seller_phone_number',
}
